// A Projector test page, in the new interface (9 October 2026):
// `pages/epure/ETest.vue`. Verdict sentences are written from the test's own
// figures; the rest of the test vocabulary comes from `projector.test`.
export default {
  titre: 'Test',
  ariane: {
    aria: 'Breadcrumb',
    pays: 'Export markets',
  },
  entete: {
    luLe: 'Read on {jour}',
    lanceLe: 'Launched on {jour}',
    prepareLe: 'Prepared on {jour}',
    comparables: 'against {n} comparables | against {n} comparable | against {n} comparables',
    pays: '{n} countries | {n} country | {n} countries',
    etalons: '{n} benchmark formats | {n} benchmark format | {n} benchmark formats',
    publics: 'asked: {noms}',
  },
  lu: {
    titre: 'What the panel read',
    question: 'The question asked',
    questions: 'The questions asked',
    comparable: 'Comparable, read without its title',
    lireTout: 'Read all',
    reduire: 'Collapse',
  },
  relecture: {
    reponses: 'The answers offered',
    bloquants: 'To fix before launch',
    avertissements: 'To review',
    limites: 'What this test will not tell you',
  },
  entre: 'between {bas} and {haut}%',
  verdict: {
    papier: {
      ecart: '{haut} would watch it most ({pctHaut}), {bas} least ({pctBas}).',
      egal: 'From one target to another, appetite stays close: from {bas} to {haut}.',
      uneCible: '{pct} of {cible} would watch it.',
      vosCibles: '{pct} of your targets would watch it.',
      panel: '{pct} of the panel would watch it.',
      classeTete: 'Against its {n} comparables, read blind, {titre} comes first. | Against its comparable, read blind, {titre} comes out ahead. | Against its {n} comparables, read blind, {titre} comes first.',
      classeDernier: 'Against its {n} comparables, read blind, {titre} comes last. | Against its comparable, read blind, {titre} falls behind. | Against its {n} comparables, read blind, {titre} comes last.',
      classeRang: 'Against its {n} comparables, read blind, {titre} comes {rang} of {sur}.',
    },
    ab: {
      aucune: 'No version stands out.',
      emporteDe: '{nom} wins by {n} points. | {nom} wins by {n} point. | {nom} wins by {n} points.',
      ecartChez: 'The gap is widest in {cible} ({ecart}).',
      aucuneRetient: '{pct} of the panel picks none of them.',
    },
    episode: {
      fin: '{pct} watch the episode to the end.',
      suite: '{pct} would watch the next episode.',
      fort: 'The moment that hooks most: sequence {n} ({horaire}), for {pct}.',
      faible: 'The one where viewers most want to drop off: sequence {n} ({horaire}), for {pct}.',
    },
    pilote: {
      fin: '{pct} watch it to the end.',
      decrochage: 'The steepest drop comes between “{a}” and “{b}” ({ecart}).',
    },
    sortie: {
      tete: '{pct} of {cible} would watch {titre} in its first week on {plateforme}{entre}, that is {personnes} people.',
      teteSansPersonnes: '{pct} of {cible} would watch {titre} in its first week on {plateforme}{entre}.',
      desLaSortie: 'On release day: {pct}.',
    },
    soiree: {
      projetee: '{programme}: {pct} projected audience share in {cible}{entre}.',
      simulee: '{programme}: {pct} simulated audience share in {cible}{entre}.',
      mesureDans: 'The published rating, {mesure}, falls within the range.',
      mesureHors: 'The published rating, {mesure}, falls outside the range.',
    },
  },
  episode: {
    jusquAuBout: 'watch it to the end',
    aime: 'liked it',
    suite: 'would watch the next episode',
    retention: 'Who is still watching, sequence by sequence',
    survol: 'Hover over a sequence to see its high points and the urge to drop off.',
    restants: '{pct} still watching',
    zone: 'Sequence {n}: {restants} still watching; high point for {fort}, wanted to drop off for {faible}.',
    sequence: 'Sequence {n}',
    vignette: 'A still from sequence {n}',
    fort: 'High point',
    faible: 'Wanted to drop off',
  },
  sortie: {
    titre: 'Release on {plateforme}',
    premiereSemaine: 'in its first week',
    personnes: '{valeur} people{bornes}',
    quand: 'When they would watch it',
    option: {
      desSaSortie: 'On release',
      dansLaSemaine: 'Within the following week',
      plusTard: 'Later',
      pasDuTout: 'Not at all',
    },
    entete: 'on {plateforme} on {jour}',
    canaux: {
      titre: 'Channel by channel',
      aide: 'The share who would watch it in its first week, depending on where they come across it.',
      canal: 'Channel',
    },
    poches: {
      titre: 'Where it takes off',
      aide: 'The audiences who would watch it soonest, given what they already love and where they come across it, each against its whole audience.',
      nom: '{affinite}, {public}',
      sur: 'on {canal}',
      tousCanaux: 'all channels together',
      contre: 'against {pct} for all {public}',
      accident: 'Where it takes off most: {nom}, {ou}. {pct} would watch it in its first week, against {reference} for all {public}.',
      accidentSansReference: 'Where it takes off most: {nom}, {ou}. {pct} would watch it in its first week.',
    },
  },
  // What a Release builds on (October 15, 2026).
  // Confirmations (October 15, 2026).
  confirmer: {
    archiver: {
      titre: 'Archive this test?',
      texte: 'It leaves the format page and its ladder. It can no longer be relaunched.',
    },
    sceller: {
      titre: 'Seal the projection?',
      texte: 'The projection is frozen and timestamped before the broadcast. It can no longer change, and an evening has only one.',
    },
  },
  appuis: {
    titre: 'What it builds on',
    bloc: {
      format_papier: 'Paper format',
      ab: 'A/B Testing',
      pilote: 'Episode',
    },
    envie: 'want to watch it, from the pitch',
    versionGagnante: 'want to watch it with “{version}”, the winning version',
    versionChoisie: 'want to watch it with “{version}”, the chosen version',
    jusquAuBout: 'watch the episode to the end',
    episodesVus: 'about {n} of {sur} episodes watched',
    voir: 'See the study',
    sortie: 'This Release’s twins saw the show the way these studies made it win.',
    soiree: 'The evening is measured on the TV guide: these studies inform the result without changing what the twins saw.',
  },
  vitrine: {
    verdict: '{pct} of {cible} would start {titre} first on {canaux}, against what is new or most watched there ({rang}).',
    lancent: 'start it first',
    rang: 'ranked {rang} of {sur}',
    rangPremier: 'ranked 1st of {sur}',
    rangCanal: '{rang} ({canal})',
    et: ' and ',
    titre: 'Against what is out',
    aide: 'What each audience starts first, channel by channel, among what is new or most watched there this week.',
    pochesAide: 'The audiences who most often start it first, given what they already love and where they come across it, each against its whole audience.',
    accident: 'Where it takes off most: {nom}, {ou}. {pct} would start it first, against {reference} for all {public}.',
    accidentSansReference: 'Where it takes off most: {nom}, {ou}. {pct} would start it first.',
  },
  papier: {
    leRegarderaient: 'would watch it',
    tropPeu: 'Too few answers for a figure',
    indifferents: '{pct} indifferent',
    indifferentsTotal: '{pct} indifferent (“I don’t mind”)',
    duo: 'Among 3-7 year-olds, {reclame} would ask for it; {retient} would watch it with their parents’ approval.',
    reponses: '{n} answers | {n} answer | {n} answers',
  },
  classe: {
    rang: '{rang} of {sur}',
    aveugle: 'The same twins read each programme, without its title.',
  },
  ab: {
    envie: 'want to watch',
    choisissent: 'pick it',
    lEmporte: 'Wins',
    devanceDePeu: 'Narrowly ahead',
    reference: 'Reference',
    enTete: 'Ahead',
    ecartReference: '{ecart} against {ref}',
    indifferents: '{pct} indifferent',
  },
  retenir: {
    titre: 'Key takeaways',
    cibleGagne: '{cible}: {nom} wins, {a} against {b}.',
    cibleEgale: '{cible}: the versions are level, from {bas} to {haut}.',
    effetTalent: '{nom}: {ecart} against {ref}.',
    talentSansEffet: 'No talent moves appetite by five points or more against {ref}.',
    papierPlus: '{nom} creates more appetite than the text alone: {papier} on paper, {version} here.',
    papierMoins: 'The text alone created more appetite: {papier} on paper, {version} for {nom}.',
    papierAutant: 'As much appetite as on paper: {papier} on paper, {version} for {nom}.',
    indifferents: '{moins} leaves the fewest indifferent ({pctMoins}), {plus} the most ({pctPlus}).',
  },
  verbatims: {
    titre: 'What they say',
    interroger: 'Ask these twins',
  },
  personas: {
    sousTitre: 'Open a profile, then talk to them about what they just saw: the conversation is kept.',
  },
}
